<p-drawer [(visible)]="visible" [position]="drawerPosition" [baseZIndex]="10000" styleClass="user-menu-sidebar u-drawer" [showCloseIcon]="false" (onHide)="closeSidebar()">

  <!-- Cream header: user identity card + close -->
  <div class="drawer-head cream">
    <div class="u-card">
      <span class="u-avatar">
        <i class="pi pi-user" aria-hidden="true"></i>
      </span>
      @if (sessionService.getSession && userProperty.userSelectedCompany) {
        <div class="u-info">
          <span class="u-name">{{ sessionService.fullName }}</span>
          <span class="u-email">{{ sessionService.email }}</span>
          <span class="u-badge">{{ userProperty.userSelectedCompany.name }}</span>
        </div>
      }
    </div>
    <button class="drawer-close" (click)="closeSidebar()" [attr.aria-label]="'app.close' | translate">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="drawer-body">

    <!-- Quick actions: account (orange) + sign out (red) -->
    <div class="u-actions">
      <button class="pill orange" (click)="navigateToAccountSettings()">
        <i class="pi pi-cog" aria-hidden="true"></i>
        <span>{{ "account.my-account" | translate }}</span>
      </button>
      <button class="pill red" (click)="signOut()">
        <i class="pi pi-sign-out" aria-hidden="true"></i>
        <span>{{ 'app.signOut' | translate }}</span>
      </button>
    </div>

    <button class="pill pill-block" (click)="navigateToPreferences()">
      <i class="pi pi-sliders-h" aria-hidden="true"></i>
      <span>{{ 'WORKSPACE.PREFERENCES.MENU_TITLE' | translate }}</span>
    </button>

    <button class="pill pill-block" (click)="navigateToNotifications()">
      <i class="pi pi-bell" aria-hidden="true"></i>
      <span>{{ 'NOTIFICATIONS.MENU_TITLE' | translate }}</span>
    </button>

    @if (notificationTemplatesAccess.canManage()) {
      <button class="pill pill-block" (click)="navigateToNotificationTemplates()">
        <i class="pi pi-envelope" aria-hidden="true"></i>
        <span>{{ 'NOTIFICATIONS.TEMPLATES.MENU_TITLE' | translate }}</span>
      </button>
    }

    @if (canManageAccountSettings) {
      <button class="pill pill-block" (click)="changePassword()">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <span>{{ "account.changepassword" | translate }}</span>
      </button>
    }

    @if (workspaceMe.canManageAny()) {
      <button class="pill pill-block" (click)="navigateToManageTemplates()">
        <i class="pi pi-clone" aria-hidden="true"></i>
        <span>{{ 'WORKSPACE.TEMPLATE.MANAGE_TITLE' | translate }}</span>
      </button>
    }

    <!-- Mobile-only: Impersonate actions -->
    @if (appProperty.impersonateIsActive) {
      <div class="um-section">
        <button pButton pRipple [loading]="appComponent.impersonateLoader"
          class="um-impersonate-btn um-impersonate-remove p-button-sm"
          (click)="appComponent.removeImpersonate(); closeSidebar()">
          <i class="p-button-icon p-button-icon-left pi pi-user-minus" aria-hidden="true"></i>
          <span class="p-button-label">{{ 'account.remove-impersonate' | translate }}</span>
        </button>
      </div>
    }

    <!-- Mobile-only: OAuth providers -->
    @if (appStateHolder.oauthState.providers.length > 0) {
      <div class="um-section um-oauth-section">
        @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
          <div class="um-oauth-item"
            [class.oauth-active]="appComponent.getOAuthProviderStatus(provider.provider) === 'active'"
            [class.oauth-expiring]="appComponent.getOAuthProviderStatus(provider.provider) === 'expiring'"
            [class.oauth-expired]="appComponent.getOAuthProviderStatus(provider.provider) === 'expired'"
            (click)="appComponent.showOAuthPanel($event, provider.provider)">
            @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
              <img src="assets/CustomIcons/microsoftprovider.svg" class="um-oauth-icon"
                alt="" aria-hidden="true" width="22" height="22" />
              <span class="um-oauth-name">Microsoft</span>
            }
            @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
              <img src="assets/CustomIcons/jiraprovider.svg" class="um-oauth-icon"
                alt="" aria-hidden="true" width="22" height="22" />
              <span class="um-oauth-name">Jira</span>
            }
            <span class="um-oauth-dot"></span>
          </div>
        }
      </div>
    }

    <!-- Company switcher -->
    <div class="u-section">{{ 'app.selectCompany' | translate }}</div>
    <div class="u-list">
      @for (company of userProperty.userCompaniesList; track $index) {
        <button class="u-row"
          [class.active]="userProperty.userSelectedCompany && company.id === userProperty.userSelectedCompany.id"
          (click)="appComponent.changeCompany(company)">
          <span class="ic">
            <i class="pi pi-building" aria-hidden="true"></i>
          </span>
          <span class="nm">{{ company.name }}</span>
          @if (userProperty.userSelectedCompany && company.id === userProperty.userSelectedCompany.id) {
            <span class="check" aria-hidden="true">
              <i class="pi pi-check"></i>
            </span>
          }
        </button>
      }
    </div>

  </div>

</p-drawer>
